import { useRef, useState } from 'react';
import { createGlobalStore } from 'hox';

export const [useGlobalStore, getGlobalStore] = createGlobalStore(() => {
    const dragDrawerWidthConfig = useRef({
        maxWidth: document.body.clientWidth > 1350 ? 1350 : document.body.clientWidth - 70,
        minWidth: 400,
    });

    const [dragDrawerWidth, setDragDrawerWidth] = useState(
        Number(localStorage?.getItem('dragDrawerWidth')) || dragDrawerWidthConfig.current.minWidth
    );

    const setDragDrawerWidthForMax = () => {
        const maxWidth = dragDrawerWidthConfig.current.maxWidth;
        setDragDrawerWidth(maxWidth);
        localStorage.setItem('dragDrawerWidth', `${maxWidth}`);
    };

    const setDragDrawerWidthForMin = () => {
        const minWidth = dragDrawerWidthConfig.current.minWidth;
        setDragDrawerWidth(minWidth);
        localStorage.setItem('dragDrawerWidth', `${minWidth}`);
    };

    return {
        dragDrawerMaxWidth: dragDrawerWidthConfig.current.maxWidth,
        dragDrawerMinWidth: dragDrawerWidthConfig.current.minWidth,
        dragDrawerWidth,
        setDragDrawerWidth,
        setDragDrawerWidthForMax,
        setDragDrawerWidthForMin,
    };
});
